import React from 'react';

export const Alert = ({ children, variant = 'default', className = '' }) => {
  const baseStyles = 'px-4 py-3 rounded-lg flex items-center gap-2';
  const variantStyles = {
    default: 'bg-gray-100 text-gray-800',
    destructive: 'bg-red-50 text-red-600',
    warning: 'bg-yellow-50 text-yellow-600',
    success: 'bg-green-50 text-green-600'
  };

  return (
    <div className={`${baseStyles} ${variantStyles[variant]} ${className}`}>
      {children}
    </div>
  );
};

export const AlertDescription = ({ children }) => (
  <div className="text-sm font-medium">
    {children}
  </div>
);